import React from 'react'
import { Col } from 'react-grid-system'

import * as styles from './styles.module.scss'
import { AuditCardsProps } from './types'
import { AuditCard } from '../..'
import { AuditStatus } from '../../../views/audits/allAudits/enums'

const AuditCards = ({ data, isWorkingView, ...props }: AuditCardsProps) =>
    isWorkingView ? (
      <>
         <Col lg={6} xl={4}>
            <h2 className={styles.columnTitle}>Draft</h2>
            {data?.some((d) => d.Status === AuditStatus.DRAFT) && (
               <section className={styles.columnContainer}>
                  {data
                     ?.filter((d) => d.Status === AuditStatus.DRAFT)
                     .map((d) => (
                        <AuditCard key={d.AuditID} audit={d} {...props} />
                     ))}
               </section>
            )}
         </Col>

         <Col lg={6} xl={4}>
            <h2 className={styles.columnTitle}>Sent / In Progress</h2>
            {data?.some(
               (d) =>
                  d.Status === AuditStatus.SENT ||
                  d.Status === AuditStatus.IN_PROGRESS
            ) && (
               <section className={styles.columnContainer}>
                  {data
                     ?.filter(
                        (d) =>
                           d.Status === AuditStatus.SENT ||
                           d.Status === AuditStatus.IN_PROGRESS
                     )
                     .map((d) => (
                        <AuditCard key={d.AuditID} audit={d} {...props} />
                     ))}
               </section>
            )}
         </Col>
         <Col lg={6} xl={4}>
            <h2 className={styles.columnTitle}>For Review</h2>
            {data?.some((d) => d.Status === AuditStatus.FOR_REVIEW) && (
               <section className={styles.columnContainer}>
                  {data
                     ?.filter((d) => d.Status === AuditStatus.FOR_REVIEW)
                     .map((d) => (
                        <AuditCard key={d.AuditID} audit={d} {...props} />
                     ))}
               </section>
            )}
         </Col>
      </>
   ) : (
      data?.map((d) => (
         <Col lg={6} xl={4} key={d.AuditID}>
            <AuditCard audit={d} {...props} />
         </Col>
      ))
   )

export default AuditCards
